/**
 * Layout for the Exec section — uses ExecNav instead of UnifiedTopNav.
 * Wraps all /exec/* routes.
 */
import { Outlet } from 'react-router-dom'
import AppShell from '../components/ui/AppShell'
import UserMenu from '../components/ui/UserMenu'
import { EXEC_NAV } from './navConfig'
import { useTypedNavigate, ROUTES } from '../lib/routing'
import { useUser } from '../contexts/UserContext'

const ExecLayout = () => {
  const navigate = useTypedNavigate()
  const { user, logout } = useUser()

  const handleLogout = () => {
    logout()
    navigate(ROUTES.public.login)
  }

  return (
    <AppShell
      nav={EXEC_NAV}
      homeTo="/exec"
      footer={(collapsed) => (
        <UserMenu
          collapsed={collapsed}
          onLogout={handleLogout}
          userName={user?.full_name || 'User'}
          userOfficeName={user?.office?.name || 'Office'}
        />
      )}
    >
      <Outlet />
    </AppShell>
  )
}

export default ExecLayout
